import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleDeleteInquiryDraft } from './actions';
import { IDeleteInquiryDraftState } from './slice.interface';

const initialState: IDeleteInquiryDraftState = {
  isLoading: false,
};

export const deleteInquiryDraftSlice = createSlice({
  name: 'delete-inquiry-draft',
  initialState,
  reducers: {
    removeADeleteInquiryDraft: state => {
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleDeleteInquiryDraft.pending, (state: IDeleteInquiryDraftState) => {
        state.isLoading = true;
      })
      .addCase(handleDeleteInquiryDraft.fulfilled, (state: IDeleteInquiryDraftState) => {
        state.isLoading = false;
        eventBus.emit(EventType.DELETE_INQUIRY_DRAFT_SUCCESS);
      });
  },
});

export const { removeADeleteInquiryDraft } = deleteInquiryDraftSlice.actions;

export default deleteInquiryDraftSlice.reducer;
